import React from "react";
import "./modal.css"

export const Modal = ({ children, open, onClose = () => { } }) => {
    return <div className={`modal modal-backdrop ${open ? "modal-show" : ""}`} onClick={onClose}>
        <a className="modal-close" onClick={onClose}>&times;</a>
        <div className="modal-body" onClick={(evt) => evt.stopPropagation()}>
            {children}
        </div>
    </div >
}